import styled from 'styled-components';
import { color } from 'styles/colors';

export const centralize = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;

  > p {
    font-size: 0.8rem;
    color: ${color.interface.white};
  }
`;
